<template>
    <psi-detail-card
        :items="items"
        headingTitle="Court Case"
        icon="mdi-scale-balance"
    ></psi-detail-card>
</template>

<script>
export default {
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    computed: {
        items() {
            return [
                {
                    text: this.caseDetails.caseId,
                    icon: "mdi-gavel",
                    label: "Case Number",
                },
                {
                    text: this.caseDetails.case.caseTitle,
                    icon: "mdi-card-text-outline",
                    label: "Title",
                },

                {
                    text: this.caseDetails.judgement,
                    icon: "mdi-account-check-outline",
                    label: "Judgement",
                },
                {
                    text: this.caseDetails.case.codeCaseType,
                    icon: "mdi-select-search",
                    label: "Type",
                },
                {
                    text: this.caseDetails.fileDate,
                    icon: "mdi-calendar",
                    label: "File Date",
                },
                {
                    text: this.caseDetails.case.codeNode,
                    icon: "mdi-routes",
                    label: "County",
                },
                {
                    text: this.caseDetails.case.codeCaseStatus,
                    icon:
                        this.caseDetails.case.codeCaseStatus === "Closed"
                            ? "mdi-clipboard-check"
                            : "mdi-clipboard-alert",
                    label: "Status",
                    type: "chip",
                    class: "text-uppercase",
                    color:
                        this.caseDetails.case.codeCaseStatus === "Closed"
                            ? "primary"
                            : "warning darken-2",
                    size: "medium",
                    align: "left",
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
</style>